/**
 * Task Time Diff Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.taskTimeDiffFormatter = function(value, row) {
    let html = '';
    if (row.time_diff.time_planned && row.time_diff.time_spent && row.time_diff.time_diff !== 0) {
        if (parseInt(row.time_diff.time_planned, 10) < parseInt(row.time_diff.time_spent, 10)) {
            html += '<span class="badge badge-pill badge-time-diff-plus">';
            html += '+'+row.time_diff.formatted;
            html += '</span>';
        } else {
            html += '<span class="badge badge-pill badge-time-diff-minus">';
            html += row.time_diff.formatted;
            html += '</span>';
        }
    }
    return html;
};
